// extracted by mini-css-extract-plugin
module.exports = {"container":"ya","copy":"za","field":"Aa","error":"Ba","disabled":"Ca","termsContainer":"Da","termsHeading":"Ea","termsCopy":"Fa","submit":"Ga","srOnly":"Ha"};